export default __webpack_public_path__ + "static/media/edit-icon.412dadb4.svg";